/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Fri Jul 07 2023
 **/

import { DependencyList } from "react";
import { useStompClient } from "@/frameworks/libraries/network";
import useUnityCommand from "./useUnityCommand";
import { Topics } from "../commons";

export default function useUnityNetwork(deps: DependencyList = []) {
	const unityCommand = useUnityCommand();

	useStompClient(
		{
			onMessageReceived: (message) => {
				const { type, payload } = message;
				switch (type) {
					case "sendMessage": {
						unityCommand.receiveMessage(payload);
						break;
					}
				}
			}
		},
		deps
	);

	useStompClient(
		{
			onMessageReceived: (message, topic) => {
				if (!topic.startsWith(Topics.Unity)) return;
				unityCommand.sendMessage(message);
			}
		},
		deps
	);
}
